<template>
  <div class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">{{ brinde.id ? "Editar Brinde" : "Novo Brinde" }}</h4>
      <button class="btn btn-secondary btn-sm me-3" @click="voltar">Voltar</button>
    </div>
    <BaseForm 
      :submitText="brinde.id ? 'Salvar' : 'Salvar'"
      :cancelText="'Cancelar'"
      :isFormValid="isFormValid" 
      :isSubmitting="isSubmitting"
      @submit="salvarBrinde" 
      @cancel="voltar"
    >
      <!-- Dados do Brinde -->
      <FormSection title="Informações do Brinde">
        <!-- Nome e Status na mesma linha -->
        <div class="d-flex justify-content-between">
          <div class="form-group flex-grow-1 me-3">
            <InputField
              id="nome"
              label="Nome <span class='required'>*</span>"
              type="text"
              v-model="brinde.nome"
              :class="{ 'error-input': errors.nome }"
              placeholder="Digite o nome do brinde"
              width="400px"
            />
          </div>
  
          <div class="form-group">
            <label for="status">Status <span class="required">*</span></label>
            <div class="form-switch">
              <input
                type="checkbox"
                id="status"
                v-model="brinde.ativo"
                class="form-check-input"
              />
              <label for="status" class="form-check-label">
                {{ brinde.ativo ? "Ativo" : "Inativo" }}
              </label>
            </div>
          </div>
        </div>
      </FormSection>
  
      <FormSection title="">
        <div class="form-group full-width">
          <label for="descricao">Descrição</label>
          <textarea
            id="descricao"
            v-model="brinde.descricao"
            class="form-control"
            placeholder="Digite a descrição do brinde"
            rows="3"
          ></textarea>
        </div>
      </FormSection>
    </BaseForm>
  </div>
</template>
  
<script>
import { reactive, ref, computed, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import axios from "@/services/axios";
import BaseForm from "@/components/Layout/BaseForm.vue";
import FormSection from "@/components/Layout/FormSection.vue";
import InputField from "@/components/Layout/InputField.vue";

export default {
  components: { BaseForm, FormSection, InputField },
  setup() {
    const router = useRouter();
    const route = useRoute();

    const brinde = reactive({
      id: null,
      nome: "",
      descricao: "",
      ativo: true,
    });

    const errors = reactive({});
    const isSubmitting = ref(false);

    // Carregar detalhes do brinde
    const carregarBrinde = async () => {
      const id = route.params.id;
      if (!id) return;

      try {
        const response = await axios.get(`/cadastros/brindes/${id}`);
        const data = response.data;
        brinde.id = data.id;
        brinde.nome = data.nome;
        brinde.descricao = data.descricao;
        brinde.ativo = data.ativo;
      } catch (error) {
        console.error("Erro ao carregar brinde:", error);
      }
    };

    const validateForm = () => {
      errors.nome = brinde.nome ? "" : "O nome é obrigatório.";
    };

    const isFormValid = computed(() => {
      return Boolean(!Object.values(errors).some((error) => error) && brinde.nome);
    });

    const salvarBrinde = async () => {
      if (isSubmitting.value) return;

      validateForm();

      if (!isFormValid.value) {
        console.error("O formulário contém erros:", errors);
        return;
      }

      isSubmitting.value = true;
      try {
        const method = brinde.id ? "put" : "post";
        const url = brinde.id
          ? `/cadastros/brindes/${brinde.id}`
          : "/cadastros/brindes";

        await axios[method](url, brinde);
        router.push("/cadastros/brindes");
      } catch (error) {
        console.error("Erro ao salvar brinde:", error);
      } finally {
        isSubmitting.value = false;
      }
    };

    const voltar = () => {
      router.push("/cadastros/brindes");
    };

    onMounted(() => {
      carregarBrinde();
    });

    return {
      brinde,
      errors,
      isFormValid,
      isSubmitting,
      salvarBrinde,
      voltar,
    };
  },
};
</script>
  
<style scoped>
.required {
  color: red;
}

.form-switch {
  display: flex;
  align-items: center;
  gap: 10px;
}

.d-flex {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.form-group.full-width {
  width: 100%;
  box-sizing: border-box;
}
</style>
